const menu = [
  {
    header: 'Central de informações',
    profile: ['super_admin'],
  },
  {
    title: 'Início',
    route: 'home',
    icon: 'HomeIcon',
    profile: ['super_admin'],
  },
  {
    header: 'Cadastros',
    profile: ['super_admin'],
  },
  {
    title: 'Cursos',
    route: 'courses.list',
    icon: 'BookOpenIcon',
    profile: ['super_admin'],
  },
// :crud-operations://
]

export default menu
